import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import 'moment/locale/vi';
import PageTable, {
  PageTableCell,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import { EnumPage, EnumPagingMode } from '../../../../constants/enum';
import { COMMON_CONST } from '../../../../constants/constants';
import { trans } from '../../../../localization/index';
import { formatCurrency, isEmpty } from '../../../../utils/utils';
import OrderActionColumn from './OrderActionColumn';
import {
  changeTableActivePage,
  changeTablePageSize,
} from '../../../../redux/genericAction';
import { getListInfo } from '../actions';

class TableManagementTable extends Component {
  static renderHeader() {
    return (
      <thead>
        <tr style={{ fontWeight: 'bold' }}>
          <th style={{ width: '80px' }}>{trans('mtn_header_stt')}</th>
          <th style={{ width: '100px' }}>{trans('mtn_header_order_code')}</th>
          <th style={{ width: '160px' }}>{trans('mtn_header_restaurant')}</th>
          <th style={{ width: '100px' }}>{trans('mtn_header_city')}</th>
          <th style={{ width: '160px' }}>{trans('mtn_header_arrive_time')}</th>
          <th style={{ width: '130px' }}>{trans('mtn_header_real_adult_number')}</th>
          <th style={{ width: '150px' }}>{trans('mtn_header_additional_info')}</th>
          <th style={{ width: '110px' }} className="text-center">{trans('common_status')}</th>
          <th style={{ width: '150px' }}>{trans('mtn_header_user_note')}</th>
          <th style={{ width: '150px' }}>{trans('mtn_header_merchant_note')}</th>
          <th style={{ width: '130px' }} className="text-center">{trans('mtn_header_bill_number')}</th>
          <th style={{ width: '130px' }} className="text-center">{trans('mtn_header_bill_code')}</th>
          <th style={{ width: '130px' }} className="text-center">{trans('mtn_header_total_bill_amount')}</th>
          <th style={{ width: '100px' }} className="text-center" />
        </tr>
      </thead>
    );
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={13}>
          {trans('mtn_table_not_found')}
        </PageTableCell>
      </PageTableRow>
    );
  }

  renderRow = (row, index) => {
    const {
      language,
      openRejectModal,
      openReportModal,
      openMerchantNoteModal,
      openBillCodeAndTotalBillModal,
    } = this.props;
    const {
      id,
      deposit_amount,
      order_code: orderCode,
      arrive_time: arriveTime,
      real_adult_number: realAdultNumber,
      children_number: childrenNumber,
      commission,
      user_note: userNote,
      merchant_note: merchantNote,
      user_info: userInfo,
      arising_amount: arisingAmount,
      order_status_info: orderStatusInfo,
      item,
      occasion_info: occasionInfo,
      province_info: provinceInfo,
      merchant_info: merchantInfo,
      bill_number: billNumber,
      bill_code: billCode,
      total_bill_amount: totalBillAmount,
    } = row;
    const { full_name: fullName, phone } = userInfo;
    const arriveTimeOrder = moment(arriveTime, COMMON_CONST.FormatDateTime);

    return (
      <PageTableRow key={id}>
        <PageTableCell>{index}</PageTableCell>
        <PageTableCell>
          <strong>{orderCode}</strong>
          <br />
          <strong>{fullName}</strong>
          <div className="pt-2 pb-1">{phone}</div>
        </PageTableCell>
        <PageTableCell>
          {merchantInfo ? merchantInfo.name : ''}
        </PageTableCell>
        <PageTableCell>
          {provinceInfo ? provinceInfo.name : ''}
        </PageTableCell>
        <PageTableCell style={{ textTransform: 'capitalize' }}>
          {`${arriveTimeOrder
            .locale(language)
            .format('dddd')} - ${arriveTimeOrder.format(
            COMMON_CONST.FormatDateView,
          )}`}
        </PageTableCell>
        <PageTableCell>
          <div>{`${realAdultNumber} ${trans('adult')}`}</div>
          <div>{`${childrenNumber} ${trans('children')}`}</div>
        </PageTableCell>
        <PageTableCell>
          {deposit_amount > 0 && (
            <div>
              <strong>{trans('deposit')}: </strong>
              <strong className="text-blue">
                {formatCurrency(deposit_amount)}
              </strong>
            </div>
          )}
          <div>
            <strong>{trans('common_discount')}: </strong>
            <strong className="text-green">{item.discount}</strong>
          </div>
          <div>
            <strong>{trans('mod_detail_total_commission')}: </strong>
            <strong className="text-blue">{formatCurrency(commission)}</strong>
          </div>
          <div>
            <strong>{trans('mtn_header_deposit_amount')}: </strong>
            <strong className="text-blue">
              {formatCurrency(arisingAmount)}
            </strong>
          </div>
          <div className="font-weight-bold">
            {occasionInfo ? occasionInfo.name : ''}
          </div>
        </PageTableCell>
        <PageTableCell
          className="font-weight-bold text-black"
          textAlign="center"
          verticalAlign="middle"
        >
          {orderStatusInfo.text}
        </PageTableCell>
        <PageTableCell
          className="text-center-middle text-black font-italic"
          textAlign="left"
        >
          {userNote}
        </PageTableCell>
        <PageTableCell
          className="text-center-middle text-black font-italic "
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {
            !isEmpty(merchantNote) &&
            <div
              className="merchant-note"
              style={{ WebkitBoxOrient: 'vertical' }}
            >
              {merchantNote}
            </div>
          }
          <i
            className="fas fa-pencil-alt icon-hover"
            style={{ color: '#3c8dbc' }}
            title={trans('confirm_booking_order')}
            onClick={() => openMerchantNoteModal(row)}
          />
        </PageTableCell>
        <PageTableCell textAlign="center">
          {billNumber}
        </PageTableCell>
        <PageTableCell textAlign="center">
          {billCode}
        </PageTableCell>
        <PageTableCell textAlign="center">
          {formatCurrency(totalBillAmount)}
        </PageTableCell>
        <PageTableCell textAlign="center" verticalAlign="middle">
          <OrderActionColumn
            data={row}
            openRejectModal={openRejectModal}
            openReportModal={openReportModal}
            openBillCodeAndTotalBillModal={openBillCodeAndTotalBillModal}
          />
        </PageTableCell>
      </PageTableRow>
    );
  };

  renderExtraRowInfo = () => {
    const { table, filters } = this.props;
    const { isShowTotal } = filters;
    if (!isShowTotal) {
      return null;
    }
    const { extendedData } = table;
    const {
      totalAdultNumber,
      totalArisingAmount,
      totalRealAdultNumber,
    } = extendedData;

    return (
      <React.Fragment>
        <PageTableRow>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {trans('total_customer')}:
          </PageTableCell>
          <PageTableCell textAlign="center" className="font-weight-bold">
            {totalAdultNumber}
          </PageTableCell>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {trans('total_real_customer')}:
          </PageTableCell>
          <PageTableCell textAlign="center" className="font-weight-bold">
            {totalRealAdultNumber}
          </PageTableCell>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {trans('mtn_header_deposit_amount')}:
          </PageTableCell>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {formatCurrency(totalArisingAmount, '')}
          </PageTableCell>
          <PageTableCell colSpan="3" />
        </PageTableRow>
      </React.Fragment>
    );
  };

  render() {
    const {
      table,
      changeTableActivePageConnect,
      changeTablePageSizeConnect,
      getListInfoConnect,
    } = this.props;
    return (
      <React.Fragment>
        {this.renderExtraRowInfo()}
        <PageTable
          className="order-table"
          paginationMode={EnumPagingMode.PAGING_IDS.id}
          table={table}
          renderHeader={TableManagementTable.renderHeader}
          renderRow={this.renderRow}
          renderEmpty={TableManagementTable.renderEmpty}
          changeActivePage={changeTableActivePageConnect}
          changePageSize={changeTablePageSizeConnect}
          getList={getListInfoConnect}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  table: state.table.order.table,
  filters: state.table.order.filters,
  language: state.setting.language,
  itemEdit: state.table.order.itemEdit,
});

const mapDispatchToProps = dispatch => {
  const PAGE = EnumPage.TABLE_MANAGEMENT.id;
  return {
    changeTableActivePageConnect: activePage => {
      dispatch(changeTableActivePage(PAGE, activePage));
    },
    changeTablePageSizeConnect: pageSize => {
      dispatch(changeTablePageSize(PAGE, pageSize));
    },
    getListInfoConnect: ids => dispatch(getListInfo(ids)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableManagementTable);



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableManagementTable.jsx